__turbopack_context__.v({
  "className": "montserrat_15563de6-module__pHUIiq__className",
});
